import React from "react";
import LegalLayout from "./_LegalLayout";

const H = ({ children }) => (
  <h2 className="font-display text-xl sm:text-2xl font-semibold text-ink-900 tracking-tight mt-8">
    {children}
  </h2>
);

const Terms = () => (
  <LegalLayout
    testId="page-terms"
    overline="Legal · Terms of Use"
    title="Terms of Use"
    lead="Terms governing the use of the Allinstra website. Allinstra is an institutional systems brand by Erenown."
  >
    <p className="text-sm text-ink-500">Effective date: 16 April 2026 · Last updated: 16 April 2026</p>

    <H>1. Website purpose</H>
    <p>
      This website presents information about Allinstra’s institutional systems, solution
      areas, product portfolio, technology foundation, implementation approach, markets, legal
      notices, and business contact pathways.
    </p>

    <H>2. No professional advice</H>
    <p>
      Website content is provided for general information only. It does not constitute legal,
      tax, accounting, regulatory, investment, technical, public procurement, or other
      professional advice.
    </p>

    <H>3. Product availability and no guarantee of results</H>
    <p>
      Descriptions of products, modules, integrations, public-sector workflows, e-government
      readiness, electronic document systems, industrial zone systems, finance and revenue
      modules, decision-support structures, or implementation pathways are indicative only.
    </p>
    <p>
      Actual availability, technical feasibility, implementation timelines, legal suitability,
      and outcomes depend on the applicable jurisdiction, local legislation, public
      infrastructure, third-party access, institutional requirements, technical readiness, and
      separate agreements.
    </p>
    <p>
      Nothing on this website should be interpreted as a guarantee that any specific module,
      integration, public-system connection, e-government service, land registry access, GIS
      access, e-invoice, e-ledger, electronic signature, registered electronic mail, payment
      integration, or institutional workflow is available in every country or institution.
    </p>

    <H>4. Intellectual property</H>
    <p>
      Unless otherwise stated, website content, structure, copy, design elements, brand
      elements, logos, and original materials are owned by or licensed to the relevant Erenown
      company and/or Allinstra. Third-party names, logos, or marks remain the property of
      their respective owners.
    </p>

    <H>5. Third-party references</H>
    <p>
      References to partners, institutions, products, software providers, public authorities,
      or official resources do not mean that all services are available in all cases or that
      any particular outcome is guaranteed.
    </p>

    <H>6. Acceptable use</H>
    <p>
      You must not misuse the site, interfere with its operation, attempt unauthorised access,
      upload malicious material, or use the site for unlawful purposes.
    </p>

    <H>7. Limitation of liability</H>
    <p>
      To the fullest extent permitted by law, the relevant Erenown company disclaims liability
      for indirect, incidental, special, or consequential loss arising out of website use.
      Nothing in these Terms excludes liability that cannot lawfully be excluded.
    </p>

    <H>8. No contract formed by website use alone</H>
    <p>
      Use of the website, a form submission, or a general inquiry does not by itself create a
      binding service contract. Any engagement is subject to a separate proposal, statement of
      work, engagement letter, commercial agreement, or other signed document.
    </p>

    <H>9. Changes to the website and these terms</H>
    <p>
      We may update or discontinue content, links, service descriptions, product descriptions,
      or these Terms of Use from time to time.
    </p>

    <H>10. Governing framework</H>
    <p>
      These Terms apply to website use only. Service-specific governing law, jurisdiction,
      contracting entity, and commercial terms should be stated in the relevant commercial
      agreement or legal notice.
    </p>

    <H>Contact</H>
    <p>
      Questions about these terms can be sent to{" "}
      <a href="mailto:info@allinstra.com" className="underline">info@allinstra.com</a>.
    </p>
  </LegalLayout>
);

export default Terms;
